import { Component } from '@angular/core';

@Component({
    selector: 'app-contact-create',
    templateUrl: './contact-create.component.html',
    styleUrls: ['./contact-create.component.scss'],
    standalone: false
})
export class ContactCreateComponent {

}
